import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=39b6f0e4&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports